import type { ILocationConfigItem } from '@booking-portal/types';
import type { IResponse } from '@booking-portal/types/api';
import { httpClient } from '@booking-portal/utils/fetch-utils';

export function getLocations(
  locationIds: number[]
): Promise<IResponse<ILocationConfigItem[]>> {
  return httpClient
    .get('/location/config', {
      params: { locationIds: locationIds.join(',') },
    })
    .then((response) => response.data);
}
